import { Injectable } from "@angular/core";

@Injectable()
export class GridCellColumnStyleService {

    items = new Map<string, (params: any) => any>([
        ["name", (params) => {
            // if (params.data && params.data.color) {
            //     return { 
            //         backgroundColor: '#' + params.data.color,
            //     };
            // }
            return null;
        }]
    ]);
}
